import { EnTetePage } from '../../components/Elements';
import { CompteGoogle } from '../../components/CompteGoogle';

/**
 * Parametres de la PLATEFORME — ce qui vaut pour toutes les ecoles a la
 * fois, a distinguer du parametrage d'une entite (fiche de l'entite).
 *
 * Premier parametre (2026-10-03) : le compte technique Google, au nom
 * duquel l'application archive les documents sur les Drives partages des
 * ecoles. Le verrou est `parametre_systeme.gerer`, accordee a aucun role
 * systeme, donc detenue par le seul super admin jusqu'a ce que l'ecran
 * Roles l'ouvre a un autre.
 *
 * A savoir pour la suite : la duree d'inactivite d'une session
 * (`SESSION_INACTIVITE_MINUTES`) reste dans `backend/.env`, decision du
 * 2026-08-28. La faire descendre ici demandera de traiter son cout — elle
 * est lue a CHAQUE requete authentifiee.
 */
export function ParametresPage() {
  return (
    <>
      <EnTetePage
        titre="Paramètres"
        description="Les réglages qui valent pour toute la plateforme, et non pour une école en particulier. Le paramétrage propre à une entité se règle sur sa fiche, dans Entités."
      />

      <div className="max-w-3xl">
        <CompteGoogle />
      </div>
    </>
  );
}
